module.exports = {
  dispose3 (o) {
    o.geometry?.dispose()
    o.dispose?.()
  }
}
